import { html, css} from 'lit-element';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { BaseElement } from './BaseElement';
import {toUTCLocaleDateTimeString } from '../toUTCLocaleDateString';

import { TriggeredEvent } from '../TriggeredEvent';

const _triggeredEvent = Symbol();

export class PatientAlert extends BaseElement {
	constructor() {
		super();
		this.library.add(faExclamationTriangle);
	}
	static get styles() {
		return [
			...BaseElement.styles,
			css`
				:host {
					border: var(--theme-border, black);
					border-radius: 0.25em;
					margin: 0.5em;
					display: block;
				}
				.continer {
					display: flex;
					flex-flow: row nowrap;
				}
				.continer > div {
					flex: 0 1 auto;
					margin: 0.5em;
				}
				.icon {
					height: 2em;
				}
				@media print {
					:host {
						page-break-inside: avoid;
					}
				}
			`
		];
	}
	get triggeredEvent() {
		return this[_triggeredEvent];
	}
	set triggeredEvent(v){
		if(!(v instanceof TriggeredEvent))
			throw new TypeError('triggeredEvent must be an instance of TriggeredEvent.');
		this[_triggeredEvent] = v;
	}
	render() {
		const eventDate = new Date(this.triggeredEvent.eventDate);
		return html`
			<div class="continer">
				<div>
					<i class="icon fas fa-exclamation-triangle"></i>
				</div>
				<div>
					<div><strong>Alerted on ${eventDate.toLocaleDateString()} ${eventDate.toLocaleTimeString()}</strong></div>
					${this.triggeredEvent.description}
				</div>
			</div>
		`;
	}
}

customElements.define('pp-patient-alert', PatientAlert);